import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import './styles/main.scss';

const Toggle = ({ sizes, isOn }) => {
  const { height, width, sliderDiameter } = sizes;
  const left = (height - sliderDiameter) / 2;
  const translationAmount = width - height;
  const styles = {
    toggle: {
      height: `${height}px`,
      width: `${width}px`,
    },
    slider: {
      borderRadius: `${height}px`,
      '&:before': {
        height: `${sliderDiameter}px`,
        left: `${left}px`,
        width: `${sliderDiameter}px`,
      }
    },
    input: { // equivalent to selector 'input:checked + .slider:before {}'
      '&:checked': {
        '& + .slider': {
          '&:before': {
            transform: `translate(${translationAmount}px, 50%)`
          }
        }
      }
    },
  };

  return (
    <label
      className={`toggle ${css(styles.toggle)}`}
      htmlFor="checkbox"
    >
      <input
        className={css(styles.input)}
        checked={isOn}
        data-testid="toggle-input"
        id="checkbox"
        readOnly
        type="checkbox"
      />
      <div className={`slider ${css(styles.slider)}`} />
    </label>
  );
};

Toggle.propTypes = {
  sizes: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    sliderDiameter: PropTypes.number,
  }),
  isOn: PropTypes.bool.isRequired,
};

Toggle.defaultProps = {
  sizes: {
    height: 34,
    width: 60,
    sliderDiameter: 26,
  },
};

export default Toggle;
